import { IComponentOptions, ILocationService, IScope } from "angular";
import { IGif } from "@gtmhub/comments";
import { GtmhubController } from "@gtmhub/core";
import { GifSize, GifType, SizeOfGif, TenorGifService } from "@gtmhub/shared/services/tenor-gif.service";
import { ICheckinV2 } from "@webapp/okrs/metrics/models/metric.models";

type GifMenuPosition = "top" | "middle" | "bottom";

export class AddGIFCtrl extends GtmhubController {
  gifs: IGif[];
  showGifMenu: boolean;
  gifMenuPosition: GifMenuPosition;
  staticMenuPosition: GifMenuPosition;
  searchQuery: string;
  checkin: ICheckinV2;
  checkinDivId: string;
  setNewCommentGif: (gif: IGif, checkin?: ICheckinV2) => void;

  public static $inject = ["$scope", "$location", "TenorGifService"];

  constructor(private $scope: IScope, private $location: ILocationService, private gifService: TenorGifService) {
    super();
  }

  $onInit(): void {
    this.showGifMenu = false;
    this.getGifUrls("trending", SizeOfGif.Small);

    const unsubscribeFromQueryStringField = this.$scope.$watch("$ctrl.searchQuery", (newValue: string, oldValue: string) => {
      if (newValue !== oldValue) {
        this.getGifUrls("search", SizeOfGif.Small, newValue);
      }
    });

    const checkingDiv = document.getElementById(this.checkinDivId);
    if (this.checkinDivId) {
      checkingDiv.onclick = this.clickedOutsideOfModalListener;
    } else {
      window.onclick = this.clickedOutsideOfModalListener;
    }

    this.onDestroy(unsubscribeFromQueryStringField);
    if (this.checkinDivId) {
      this.onDestroy(() => checkingDiv.removeEventListener("click", this.clickedOutsideOfModalListener));
    } else {
      this.onDestroy(() => window.removeEventListener("click", this.clickedOutsideOfModalListener));
    }
  }

  openGifSearchModal(): void {
    this.gifMenuPosition = this.staticMenuPosition || this.getMenuPosition();
    this.showGifMenu = true;
    this.checkForEditModal();
  }

  selectGif(gif: IGif): void {
    gif.searchQuery = this.searchQuery;
    this.setNewCommentGif(gif, this.checkin);
    this.closeGifSearchModal();
  }

  closeGifSearchModal(): void {
    this.showGifMenu = false;
    this.searchQuery = "";
    this.checkForEditModal();
  }

  private clickedOutsideOfModalListener = (event) => {
    const componentClassList = event.target.parentElement?.classList || [];

    if (this.showGifMenu && !componentClassList.contains("add-gif")) {
      this.closeGifSearchModal();
      this.$scope.$apply();
    }
  };

  private getMenuPosition = (): GifMenuPosition => {
    const elementId = this.checkinDivId ? `${this.checkinDivId}-add-gif-id` : "-add-gif-id";
    const addGifElemTopOffset = document.getElementById(elementId).getBoundingClientRect().top;

    const availableHeightBot = window.screen.availHeight - addGifElemTopOffset;

    if (availableHeightBot > 650) {
      return "top";
    } else if (availableHeightBot > 500) {
      return "middle";
    } else {
      return "bottom";
    }
  };

  private checkForEditModal() {
    const absUrl = this.$location.absUrl();
    const isEditMetricUpdateModal = absUrl.includes("edit-metric-update");
    const addGifComponent = document.querySelector("add-gif") as HTMLElement;

    if (isEditMetricUpdateModal && this.showGifMenu) {
      addGifComponent.style.marginBottom = "144px";
    }

    if (isEditMetricUpdateModal && !this.showGifMenu) {
      addGifComponent.style.marginBottom = "0px";
    }
  }

  private getGifUrls(gifType: GifType, gifSize: GifSize, searchQuery = "") {
    this.gifService.getGifData({ gifType, gifSize, searchQuery }).then((response) => {
      this.gifs = response.map((x) => ({
        id: x.id,
        url: x.media.url,
      }));
    });
  }
}

export const AddGIFComponent: IComponentOptions = {
  bindings: {
    checkinDivId: "@?",
    checkin: "<?",
    setNewCommentGif: "<",
    staticMenuPosition: "<",
  },
  controller: AddGIFCtrl,
  template: require("./add-gif.component.html"),
};
